<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/KnowledgeIndex/kManageIndex' }"
          >知识付费内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>知识付费内容信息设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>知识付费内容信息设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>内容所属系列</p>
            <div class="select_box">
              <el-select
                v-model="formData.typeid"
                placeholder="请选择内容所属系列"
              >
                <el-option
                  v-for="item in konwledgeType"
                  :key="item.id"
                  :label="item.typename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>内容标题：</p>
            <div class="input_box">
              <el-input
                v-model="formData.topic"
                placeholder="输入内容标题"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>内容封面（缩略图）</p>
            <p class="red">JPG或者PNG格式，尺寸比例宽度500像素，高度不限制</p>
            <div
              class="upload_box"
              @mouseenter="enter(1)"
              @mouseleave="creenIndex = ''"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.cover">
                  <img :src="formData.cover" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span
                      @click.stop="handlePictureCardPreview(formData.cover, 1)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(1)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block">
            <p>属性</p>
            <div class="radio_box" style="margin-bottom: 10px">
              <el-radio-group v-model="formData.attrval">
                <template v-for="(item,index) in konwledgeAttr">
                  <el-radio :key="index" :label="item.attrid">{{item.attrname}}</el-radio>
                </template>
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>内容收费价格：</p>
            <div class="input_box">
              <el-input
                v-model="formData.price"
                placeholder="输入内容收费价格"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>是否启用</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.isuse">
                <el-radio label="启用">启用</el-radio>
                <el-radio label="停用">停用</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->

     <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  encryptstringview,
  getKonwledgeAttr,
  uploadImage
} from "../../../api/api";
import { addKonwledge, editKonwledge, getKonwledgeDetail, getKonwledgeType } from "../../../api/knowledge";
export default {
  name: "kBaseinfo",
  data() {
    return {
      loading: false,
      dialogImageUrl: "",
      dialogVisible: false,

      konwledgeType: [],
      konwledgeAttr: [],

      detail: "",
      formData: {
        id: '',
        typeid: '',
        qyguid: '',
        topic: '',
        cover: '',
        attrval: '',
        price: '',
        isuse: '是',
        creater: '',
      },
      creenIndex: "",
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.formData.qyguid = USERINFO.qy.qyguid;
      this.formData.creater = USERINFO.truename;
    } else {
      this.formData.qyguid = 0;
    }
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        if(id) {
          this.getDetail()
        }else {
          this.getKonwledgeAttr()
          this.getKonwledgeType()
        }
      } else {
        this.$router.back();
      }
    },

    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.cover = "";
      }
    },
    // 大图预览
    handlePictureCardPreview(url) {
       this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formData.cover = res.url;
          } 
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    getDetail() {
      this.loading = true;
      getKonwledgeDetail({ id: this.formData.id }).then((res) => {
        this.formData.typeid = res.typeid;
        this.formData.topic = res.topic
          ? res.topic
          : "";
        this.formData.cover = res.cover
          ? res.cover
          : "";
        this.formData.attrval = res.attrval
          ? res.attrval
          : "";
        this.formData.price = res.price
          ? res.price
          : "";
        this.formData.isuse = res.isuse ? res.isuse : "";
        if (res.typeid) {
          this.getKonwledgeType();
        }
        if (res.attrval) {
          this.getKonwledgeAttr();
        }

        this.loading = false;
      });
    },

    // 知识付费类型
    getKonwledgeType() {
      let params = {
        keyword: '',
        qyguid: this.formData.qyguid
      }
      getKonwledgeType(params).then((res) => {
        let filter = res.list.filter(v => v.isuse == '是')
        this.konwledgeType = filter;
      });
    },

    // 知识付费属性
    getKonwledgeAttr() {
      getKonwledgeAttr().then((res) => {
        this.konwledgeAttr = res;
      });
    },

    query() {
      let { formData } = this;
      if (formData.typeid == '') {
        this.$message.warning("请选择内容所属系列");
        return;
      }
      if (formData.topic == '') {
        this.$message.warning("请输入内容标题");
        return;
      }
      if (formData.cover == '') {
        this.$message.warning("请上传内容封面");
        return;
      }
      if (formData.attrval == '') {
        this.$message.warning("请选择属性");
        return;
      }
      if (formData.price == '') {
        this.$message.warning("请输入内容收费价格");
        return;
      }
      this.loading = true;
      if (formData.id) {
        editKonwledge(formData).then((res) => {
          if (res.result) {
            this.loading = false;
            this.$message.success(res.message);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addKonwledge(formData).then((res) => {
          if (res.result) {
            this.loading = false;
            this.$message.success(res.message);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "cManageIndex" });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>